import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription,
  AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "./ui/alert-dialog";
import { brl } from "./PurchaseDialog";
import { Layers } from "lucide-react";

export const AdminClosings = () => {
  const [data, setData] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    api.get("/admin/closings").then((r) => setData(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, []);
  useEffect(() => { load(); }, [load]);

  const run = async () => {
    setBusy(true);
    try {
      const { data: r } = await api.post("/admin/closing/run");
      toast.success(`Fechamento executado: ${brl(r.total_paid)} pagos`);
      setConfirm(false);
      load();
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };

  if (!data) return <p className="text-sm text-muted-foreground">Carregando...</p>;
  return (
    <Card className="p-6" data-testid="admin-closings">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
        <div>
          <div className="font-display text-lg font-bold flex items-center gap-2"><Layers className="h-5 w-5 text-amber-400" /> Compressão dinâmica</div>
          <p className="text-xs text-muted-foreground">
            Executa automaticamente no último dia de cada mês. Em aberto: <b data-testid="closing-open-events">{data.open_events}</b> ativação(ões),
            {" "}<b data-testid="closing-pending-amount">{brl(data.pending_amount)}</b> em saldo informativo.
          </p>
        </div>
        <Button variant="outline" onClick={() => setConfirm(true)} data-testid="closing-run-btn">Executar fechamento agora</Button>
      </div>
      {data.items.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="closings-empty">Nenhum fechamento executado ainda.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[640px]">
            <thead className="text-xs uppercase tracking-wider text-muted-foreground">
              <tr className="border-b border-border">
                <th className="text-left py-2">Execução</th><th className="text-left">Período</th><th className="text-right">Ativações</th>
                <th className="text-right">Pago</th><th className="text-right">Redistribuído</th><th className="text-left pl-4">Usuários comprimidos</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((c) => (
                <tr key={c.id} className="border-b border-border/50 align-top" data-testid={`closing-row-${c.id}`}>
                  <td className="py-2 text-xs">{new Date(c.executed_at).toLocaleString("pt-BR")}{!c.auto && <div className="text-muted-foreground">manual</div>}</td>
                  <td className="font-mono">{c.period}</td>
                  <td className="text-right font-mono">{c.events}</td>
                  <td className="text-right font-mono gold-text">{brl(c.total_paid)}</td>
                  <td className="text-right font-mono">{brl(c.redistributed)}</td>
                  <td className="pl-4 text-xs">
                    {c.compressed_users.length === 0 ? "—" : c.compressed_users.map((u) => u.name).join(", ")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <AlertDialog open={confirm} onOpenChange={setConfirm}>
        <AlertDialogContent data-testid="closing-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Executar fechamento agora?</AlertDialogTitle>
            <AlertDialogDescription>
              As comissões em aberto serão pagas aos membros ativos (80% saque + 20% Saldo Consumo). Inativos são ignorados
              e os valores sobem para o próximo ativo. Esta ação não pode ser desfeita.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction disabled={busy} onClick={(e) => { e.preventDefault(); run(); }} className="gold-btn" data-testid="closing-confirm-btn">
              {busy ? "Executando..." : "Executar"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </Card>
  );
};
